
import Vue from 'vue'

import { Context } from '@nuxt/types'
import { MetaInfo } from 'vue-meta'

import config from '@/config'

import { ArticleType, MemberType, WorkType } from '@/models'
import { handleError } from '@/plugins/helper'
import KeyVisual from '@/sections/top/key-visual.vue'
import NewsSticky from '@/sections/top/news-sticky.vue'
import AuroraBackground from '~/components/common/aurora-background.vue'
import TextPressure from '~/components/common/text-pressure.vue'
import FooterNew from '~/components/FooterNew.vue'
import TextPressureMixin from '~/mixins/text-pressure.vue'
import Article from '~/sections/top/article.vue'
// import Prism from '~/sections/top/prism.vue'
import Recruit from '~/sections/top/recruit.vue'
import Service from '~/sections/top/service.vue'
import Specialist from '~/sections/top/specialist.vue'
import Vision from '~/sections/top/vision.vue'

export default Vue.extend({
  name: 'HomePage',
  components: {
    NewsSticky,
    Vision,
    Service,
    Specialist,
    Recruit,
    KeyVisual,
    // Prism,
    TextPressure,
    Article,
    FooterNew,
    AuroraBackground
  },
  mixins: [TextPressureMixin],
  layout: 'home',
  async asyncData({ $content }: Context): Promise<object | void> {
    const [works, articles] = await Promise.all([
      $content('work/detail')
        .sortBy('publishedAt', 'desc')
        .only(['eyeCatchImage', 'title', 'members', 'tags', 'slug', 'publishedAtStr'])
        .limit(5)
        .fetch<WorkType[]>()
        .catch(handleError),
      $content('article/all')
        .limit(8)
        .only(['url', 'thumbnail', 'thumbnailUrl', 'category', 'publicDateStr', 'title', 'media'])
        .fetch<MemberType[]>()
        .catch(handleError)
    ])

    // @ts-ignore
    const memberSysIdList: string[] = works ? works.reduce((a, c) => [...a, ...c.members], []) : []

    const members = await $content('members')
      .where({ sysId: { $in: [...memberSysIdList] } })
      .fetch()
      .catch(handleError)

    return { works, members, articles: Array.isArray(articles) ? articles : [articles] }
  },
  data() {
    const works = [] as WorkType[]
    const members = [] as MemberType[]
    const articles = [] as ArticleType[]
    const baseWidth = 4.5
    const baseHeight = 4
    const baseScale = 3
    const isScrolling = false
    const isBottom = false

    return {
      works,
      members,
      articles,
      baseWidth,
      baseHeight,
      baseScale,
      isScrolling,
      isBottom
    }
  },
  head(): MetaInfo {
    const title = 'DeNA×AI｜“AIオールイン”で創るDelight'
    const extendMeta = this.$helper.setMetaTitleAndDescription(title, config.description, false)

    return {
      title,
      titleTemplate: undefined,
      meta: [...extendMeta]
    }
  },
  computed: {
    tagFilter(): string {
      const { tag } = this.$route.query
      return tag.toString().toLowerCase() || 'all'
    }
  },
  beforeMount() {
    // Set initial base width and height based on window width before Prism component initialization
    if (window.innerWidth > 1279) {
      this.baseWidth = 4.5
      this.baseHeight = 4
    } else if (window.innerWidth > 767) {
      this.baseHeight = 2
      this.baseWidth = 3
      this.baseScale = 2.5
    } else {
      this.baseWidth = 2.5
      this.baseHeight = 2
      this.baseScale = 2
    }
  }
})
